
import React, { useState, useEffect, useMemo } from 'react';
import { ScrollView, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import Modal from '../../../../../components/Modal';
import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';

import { useToast } from 'react-native-toast-notifications';
import IconButton from '../../../../../components/IconButton';

export function UnitFeeLevelModal({ unit, onRequestClose, feeLevels, communityId, onFeeLevelSaved }){
  const [selected, setSelected] = useState(unit.fee_type?.uuid);
  const [submitting, setSubmitting] = useState(false);

  const toast = useToast()

  function saveUnitFeeLevel(){
    const data = {
      fee_type_id: selected,
    }

    // console.log(data);
    setSubmitting(true)
    

    api.post(`/communities/${communityId}/units/${unit.uuid}/fees/type`, data)
    .then((response) => {
      toast.show("Tipo de cuota actualizado", {type: "success"})
      setSubmitting(false)
      onFeeLevelSaved?.()
    })
    .catch((error) => {
      setSubmitting(false)
      console.log(error);
    })
  }

  return (
    <Modal onRequestClose={onRequestClose} title={"Cambiar tipo de cuota"} style={{modal: tw`w-90`}}>
      <Text style={tw`text-gray-500 text-base font-bold mb-4 text-center`}>{unit.name}</Text>

      <View style={tw``}>
        <TouchableOpacity
          onPress={() => setSelected()}
          style={tw.style(`rounded border border-gray-400 px-3 py-2 mb-3`, !selected && `bg-gray-200/80 border-secondary border-[0.35]`)}
        >
          <Text>Sin cuota</Text>
        </TouchableOpacity>  


        {
          feeLevels?.map(feeLevel => 
            <TouchableOpacity
              key={feeLevel.uuid}
              onPress={() => setSelected(feeLevel.uuid)}
              style={tw.style(`rounded border border-gray-400 px-3 py-2 mb-3`, selected == feeLevel.uuid && `bg-gray-200/80 border-secondary border-[0.35]`)}
            >
              <Text>{feeLevel.name} - <Text style={tw`font-500`}>${feeLevel.amount}</Text></Text>
            </TouchableOpacity>  
          )
        }
      </View>

      <IconButton
        title={"Guardar"}
        disabled={unit.fee_type?.uuid == selected || submitting}
        style={tw`mt-4`}
        onPress={() => saveUnitFeeLevel()}
      />
    </Modal>
  )
}


export default function UnitFeeLevelSelector({ unit, communityId, onFeeLevelUpdated, feeTypes }) {
  const [showSelectorModal, setShowSelectorModal] = useState(false);

  return (
    <View>
      <TouchableOpacity style={tw`flex row justify-center items-center`} onPress={() => setShowSelectorModal(true)}>
        <View style={tw`flex items-end`}>
          {
            unit.fee_type ?
              <>
                <Text style={tw`text-gray-500`}>${unit.fee_type.amount}</Text>
                <Text style={tw`text-gray-400`}>{unit.fee_type.name}</Text>
              </>
              :
              <Text style={tw`text-red-400`}>Sin cuota</Text>
          }
        </View>

        <Icon name='chevron-right' style={tw.style(`ml-3`, { transform: [{ rotateZ: '90deg' }] })} />
      </TouchableOpacity>

      {
        showSelectorModal &&
          <UnitFeeLevelModal
            feeLevels={feeTypes}
            unit={unit}
            communityId={communityId}
            onRequestClose={() => setShowSelectorModal(false)}
            onFeeLevelSaved={() => {
              setShowSelectorModal(false)
              onFeeLevelUpdated?.()
            }}
          />
      }
    </View>
  )
}